<header-title [model]="headerTitle"></header-title>

<div class="row">
    <div class="col">
        <button class="btn btn-primary" type="button" [routerLink]="['/lenders/add']">Add New Lender</button>
    </div>
</div>

<section class="panel">
    <div class="row my-3">
        <div class="col col-md-6">
            <header class="panel-heading">
                <h3 class="text-gray-600 m-0">Existing Lenders</h3>
            </header>
        </div>
        <div class="col col-md-6">
            <div class="row align-items-center">
                <div class="col col-md-2 text-right">
                    <label class=" control-label">Filter:</label>
                </div>
                <div class="col-md-10">
                    <form [formGroup]="filterForm" *ngIf="filterForm">
                        <input type="text" class="form-control filter-input" formControlName="filterText" placeholder="Start typing to filter list" />
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="panel-body">
        <div class="table-responsive">
            <table class="table table-hover mb-none dark">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th class="text-center">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let lender of lendersList;index as i">
                        <td>{{i+1}}</td>
                        <td>{{lender.name}}</td>
                        <td class="actions text-center">
                            <a [routerLink]="['/lenders','edit', lender.id]" class="ps-3 pe-3 mb-1 mt-1 me-2 text-primary" title="Edit"><i class="fas fa-edit"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>
